import { PartProduct } from '@app/entities/Product';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SizesType } from '../types/catalogSchema';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';

export const fetchGetAllSizes = createAsyncThunk<
  SizesType[],
  { part: PartProduct; regionId: number; brand?: string; }
>('catalog/fetchGetAllSizes', async({ part, regionId, brand }) => {
  return await MyAxios.get(`/api/catalog/all-sizes/?regionId=${regionId}&part=${part}&brand=${brand || ''}`)
    .then(handleResponse)
    .catch(handleError);
});
